import React, { createContext, useContext, useState, useRef } from 'react';

const CopyContext = createContext(null);

export const CopyProvider = ({ children }) => {
    const [copiedField, setCopiedField] = useState(null);
    const [tooltipPosition, setTooltipPosition] = useState('center');
    const timeoutRef = useRef(null);

    const handleCopy = (label, position = 'center') => {
        // Clear any existing timeout
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        setCopiedField(label);
        setTooltipPosition(position);

        timeoutRef.current = setTimeout(() => {
            setCopiedField(null);
            setTooltipPosition('center');
            timeoutRef.current = null;
        }, 1500);
    };

    return (
        <CopyContext.Provider value={{ copiedField, tooltipPosition, handleCopy }}>
            {children}
        </CopyContext.Provider>
    );
};

export const useCopy = () => {
    const context = useContext(CopyContext);
    if (!context) {
        throw new Error('useCopy must be used within a CopyProvider');
    }
    return context;
}; 